import React from 'react';

import { css } from '@emotion/core';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { Tabs as ATabs, TabsProps } from 'antd';
import { tuple } from 'antd/lib/_util/type';

export const tYzTypeTabs = tuple('list', 'modal');

export type TYzTypeTabs = typeof tYzTypeTabs[number] | undefined;
export interface TTabsParams extends TabsProps {
  yzTypeTabs: TYzTypeTabs;
}

const { TabPane: ATabPane } = ATabs;

const handleTabStyleWithType = ({ yzTypeTabs }: TTabsParams) => {
  switch (yzTypeTabs) {
    case 'list':
      return css`
        .ant-tabs-nav {
          .ant-tabs-tab {
            font-size: 18px;
            border-top: 0 !important;

            &:hover {
              color: #363c50;
            }

            &.ant-tabs-tab-active {
              color: #363c50;
              padding-bottom: 10px;
              font-weight: bold;
            }
          }
        }

        .ant-tabs-ink-bar {
          background-color: #363c50;
        }

        .ant-tabs-bar {
          border-bottom: 1px solid #363c50;
        }
      `;
    case 'modal':
      return css`
        .ant-tabs-nav .ant-tabs-tab {
          text-align: left !important;
        }
      `;
    default:
      return '';
  }
};

export const Tabs = styled(ATabs, { shouldForwardProp: isPropValid })`
  /* ${handleTabStyleWithType} */
`;

export const DetailTabs = styled((props: any) => <ATabs {...props} type="card" />)`
  /* 시작요소: $.ant-tabs */
  /* 탭 간격 */
  &.ant-tabs-card.ant-tabs-top {
    .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
      margin: 0;
    }
    .ant-tabs-nav {
      margin-bottom: 20px;
    }
  }
  /* 탭 border */
  &.ant-tabs-card.ant-tabs-top {
    .ant-tabs-nav::before {
      border-bottom: 1px solid ${({ theme }) => theme.gray11};
    }
  }
  &.ant-tabs-card.ant-tabs-top {
    .ant-tabs-nav .ant-tabs-tab {
      border: 1px solid ${({ theme }) => theme.gray5};
      border-right: none;
      border-bottom: 1px solid ${({ theme }) => theme.gray11};
    }
    .ant-tabs-nav .ant-tabs-tab:nth-last-child(2) {
      border-right: 1px solid ${({ theme }) => theme.gray5};
    }
    /* active */
    .ant-tabs-nav .ant-tabs-tab-active {
      border: 1px solid ${({ theme }) => theme.gray11};
      border-right: 1px solid ${({ theme }) => theme.gray11} !important;
      border-bottom: none;
    }
    .ant-tabs-nav .ant-tabs-tab-active + .ant-tabs-tab {
      border-left: none;
    }
  }
  /* 탭 card */
  &.ant-tabs-card {
    /* default */
    .ant-tabs-nav .ant-tabs-tab {
      padding: 12px 30px;
      font-size: 15px;
      color: ${({ theme }) => theme.gray7};
      background: ${({ theme }) => theme.gray1};
      border-radius: 0;
    }
    /* active */
    .ant-tabs-nav .ant-tabs-tab-active {
      .ant-tabs-tab-btn {
        color: ${({ theme }) => theme.gray11};
      }
    }
  }
`;

export const TabPane = styled(ATabPane)``;
